module.exports = __webpack_public_path__ + "static/assets/35b62a95b25cb331f0b70df4e9ddcd6b.png";